<template>
    <v-card>
        <v-card-title>
            <div class="mr-3">{{ $t('event.icon') }}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{ $t('Cancel') }}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{ $t('Save') }}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{ $t('Reorder') }}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddIcon">
                {{ $t('add') }}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="tableIcon" :loading="isIconPending" @pagination="currentPagination">
            <template v-slot:item.scroller="{ value }">
                <div v-show="isEditOrderMode" class="handle"><v-btn icon><v-icon>drag_handle{{ value }}</v-icon></v-btn>
                </div>
                <div v-show="!isEditOrderMode"></div>
            </template>
            <template v-slot:item.order="{ value }">
                {{ value }}
            </template>
            <template v-slot:item.icon="{ value }">
                <v-img v-if="value" :src="getFileUrl(value)" max-width="50px" max-height="50px"></v-img>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode" @click="initEditIcon(item)">
                    {{ $t('edit') }}
                    <v-icon right>mdi-pencil</v-icon>
                </v-btn>
                <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                    @click="deleteIcon(item)">
                    {{ $t('delete') }}
                    <v-icon right>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="editIconDialogShown" max-width="600px" persistent scrollable :retain-focus="false">
            <v-card>
                <v-card-title>
                    {{ $t('event.icon') }}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="isEditIconFormValid">
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_icon.key')"
                                        :placeholder="$t('event_icon.key')" v-model="editingIcon.key"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-file-input outlined accept="image/*" :label="$t('event_icon.icon')" :placeholder="$t('event_icon.icon')"
                                        v-model="editingIcon.icon">
                                        <template v-slot:selection="{ file }">
                                            <v-img :src="getFileUrl(file)" max-width="100px" max-height="100px"></v-img>
                                        </template>
                                    </v-file-input>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_icon.icon_url')"
                                        :placeholder="$t('event_icon.icon_url')" v-model="editingIcon.icon_url"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_icon.name')"
                                        :placeholder="$t('event_icon.name')" v-model="editingIcon.name"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_icon.name_tc')"
                                        :placeholder="$t('event_icon.name_tc')" v-model="editingIcon.name_tc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_icon.name_sc')"
                                        :placeholder="$t('event_icon.name_sc')" v-model="editingIcon.name_sc"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_icon.action')"
                                        :placeholder="$t('event_icon.action')"
                                        v-model="editingIcon.action"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="mb-0 pb-0">
                                    <v-text-field outlined :label="$t('event_icon.remarks')"
                                        :placeholder="$t('event_icon.remarks')"
                                        v-model="editingIcon.remarks"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="pb-0">{{$t('event_icon.description')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingIcon.description"
                                    ></froala>
                                </v-col>
                            </v-row>
                             <v-row>
                                <v-col class="pb-0">{{$t('event_icon.description_tc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingIcon.description_tc"
                                    ></froala>
                                </v-col>
                            </v-row>
                             <v-row>
                                <v-col class="pb-0">{{$t('event_icon.description_sc')}}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <froala
                                        v-if="showEditor"
                                        :config="froalaConfig"
                                        v-model="editingIcon.description_sc"
                                    ></froala>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="secondary" @click="confirmCancelItemDialogShown = true">{{ $t('cancel') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="confirmSaveItemDialogShown = true"
                        :disabled="!isEditIconFormValid">{{$t('save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <PopupAlert v-model="confirmCancelItemDialogShown" title="Warning"
            message="Do you wish to cancel your amendments?" :onYes="cancelEditIconItem"
            :onNo="function () { confirmCancelItemDialogShown = false; }"></PopupAlert>
        <PopupAlert v-model="confirmSaveItemDialogShown" title="Confirm"
            message="Do you wish to confirm to save your icon?" :onYes="saveIcon"
            :onNo="function () { confirmSaveItemDialogShown = false; }"></PopupAlert>
    </v-card>
</template>

<style scoped>
    .button-spacer {
        width: 10px;
    }
</style>

<script>
import { computed, ref, onMounted } from "@vue/composition-api";
import { useFind } from "feathers-vuex";
import { DateTime } from "luxon";
import { cloneDeep } from "lodash";
import PopupAlert from "../../components/PopupAlert";
import Sortable from "sortablejs";
import froalaConfig from "../../froala-config";

export default {
    name: 'EventIcon',
    components: { PopupAlert },
    setup(props, { root }) {
        const { EventIcon } = root.$FeathersVuex.api;

        const showEditor = ref(false);

        const eventId = computed(() => root.$route.params.eventId);

        const iconParams = computed(() => {
            return {
                query: {
                    eventId: eventId.value
                }
            }
        });
        const { items: iconItems, isPending: isIconPending } = useFind({
            model: EventIcon,
            params: iconParams,
        });
        // Data Table
        const headers = ref([
            { text: '', value: 'scroller', width: 80 },
            { text: root.$t('event_icon.order'), value: 'order' },
            { text: root.$t('event_icon.key'), value: 'key' },
            { text: root.$t('event_icon.icon'), value: 'icon' },
            { text: root.$t('event_icon.name'), value: 'name' },
            { text: root.$t('event_icon.action'), value: 'action' },
            { text: root.$t('event_icon.remarks'), value: 'remarks' },
            { text: '', value: 'actions' },
        ]);

        // Order
        const isEditOrderMode = ref(false);
        const didOrderChange = ref(false);
        const editOrderIcon = ref([]);
        const overlay = ref(false);

        // Add / Edit
        const editIconDialogShown = ref(false);
        const confirmCancelItemDialogShown = ref(false);
        const confirmSaveItemDialogShown = ref(false);
        const isEditIconFormValid = ref(false);
        const editingIcon = ref(new EventIcon({ eventId: eventId.value }));
        const initAddIcon = function () {
            editingIcon.value = new EventIcon({ eventId: eventId.value });
            editingIcon.value.order = iconItems.value.length + 1;
            editIconDialogShown.value = true;
        };
        const initEditIcon = function (icon) {
            editingIcon.value = cloneDeep(icon);
            editIconDialogShown.value = true;
        };
        const deleteIcon = function (icon) {
            if (confirm(root.$t('event_icon.confirm_delete'))) {
                icon.remove();
            }
        };
        const saveIcon = async function () {
            if (editingIcon.value.icon instanceof File) {
                editingIcon.value.icon = { src: await root.$uploadFile(editingIcon.value.icon) };
            }
            if (!editingIcon.value.icon) {
                editingIcon.value.icon = null;
            }

            editingIcon.value.save().then(() => {
                EventIcon.get(editingIcon.value.id);
                editIconDialogShown.value = false;
                confirmSaveItemDialogShown.value = false;
                root.$store.dispatch('showSnackBar', root.$t('event_icon.save_successful'));
            }, root.$handleFeatherError.bind(root))
                .finally(() => {
                      editingIcon.value.description = '';
                      editingIcon.value.description_tc = '';
                      editingIcon.value.description_sc = '';
                });
        };

        const previewHtmlContentOption = {
            modules: {
                toolbar: false,
            },
            placeholder: '',
            theme: 'bubble',
        };

        const cancelEditIconItem = function () {
            editIconDialogShown.value = false;
            confirmCancelItemDialogShown.value = false;
            editingIcon.value.description = '';
            editingIcon.value.description_tc = '';
            editingIcon.value.description_sc = '';
        }

        const initEditOrder = function () {
            didOrderChange.value = false
            isEditOrderMode.value = true
            editOrderIcon.value = cloneDeep(sortedIcon.value)
        }

        const saveEditOrder = async function () {
            if (!didOrderChange.value) {
                isEditOrderMode.value = false
                return;
            }

            overlay.value = true
            for (let i = 0; i < editOrderIcon.value.length; i++) {
                await editOrderIcon.value[i].save().then(() => {
                    EventIcon.get(editOrderIcon.value[i].id)
                })
            }
            isEditOrderMode.value = false
            overlay.value = false
        }

        const cancelEditOrder = function () {
            isEditOrderMode.value = false
        }
        const quickSortIcon = function (sortIcon) {
            if (sortIcon.length < 2) {
                return sortIcon
            }

            const chosenIndex = sortIcon.length - 1
            const chosen = sortIcon[chosenIndex]
            const a = []
            const b = []
            for (let i = 0; i < chosenIndex; i++) {
                const temp = sortIcon[i].order
                temp < chosen.order ? a.push(sortIcon[i]) : b.push(sortIcon[i])
            }
            const output = [...quickSortIcon(a), chosen, ...quickSortIcon(b)]
            return output
        }

        const sortedIcon = computed(() => {
            return quickSortIcon(iconItems.value)
        })
        const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
        const currentPagination = function (e) { // Update current page
            currentStart.value = e.pageStart
        }
        onMounted(() => {
            let table = document.querySelector('.v-data-table tbody');
            Sortable.create(table,
                {
                    handle: ".handle", // Look for class with name "handle"
                    onEnd({ newIndex, oldIndex }) {
                        didOrderChange.value = true;
                        newIndex += currentStart.value;
                        oldIndex += currentStart.value;
                        const rowSelected = editOrderIcon.value.splice(oldIndex, 1)[0];
                        editOrderIcon.value.splice(newIndex, 0, rowSelected);

                        for (let i = 0; i < editOrderIcon.value.length; i++) {
                            editOrderIcon.value[i].order = i + 1
                        }
                        editOrderIcon.value = quickSortIcon(editOrderIcon.value);
                    }
                }
            )
        });

        const tableIcon = computed(() => {
            return isEditOrderMode.value ? editOrderIcon.value : sortedIcon.value
        })

        return {
            showEditor,

            iconItems,
            isIconPending,

            headers,
            tableIcon,

            editIconDialogShown,
            confirmCancelItemDialogShown,
            confirmSaveItemDialogShown,
            initAddIcon,
            initEditIcon,
            deleteIcon,
            isEditIconFormValid,
            editingIcon,
            saveIcon,
            cancelEditIconItem,

            DateTime,
            getFileUrl: root.$getFileURL,

            previewHtmlContentOption,
            currentPagination,

            initEditOrder,
            saveEditOrder,
            cancelEditOrder,

            isEditOrderMode,
            overlay,

            froalaConfig: {
                ...froalaConfig,
                toolbarSticky: false
            },
        }
    },
    mounted() {
        setTimeout(() => {
           this.showEditor = true;
        }, 100);
    }
}
</script>
